export default __webpack_public_path__ + "static/media/pdf_logo_jpg_thumbnail.1f20a3db.jpg";